import React from 'react';

export function RatingStartHalfMobile() {
	return (
		<svg
			width="24"
			height="23"
			viewBox="0 0 24 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_519_1517)">
				<path
					d="M12.9372 1.19454C12.8737 1.06655 12.7758 0.958833 12.6544 0.883524C12.5331 0.808215 12.3931 0.768311 12.2502 0.768311C12.1074 0.768311 11.9674 0.808215 11.846 0.883524C11.7246 0.958833 11.6267 1.06655 11.5633 1.19454L8.42456 7.55327L1.40649 8.57294C1.26489 8.5935 1.13186 8.65328 1.02247 8.74551C0.913076 8.83775 0.831678 8.95876 0.787484 9.09485C0.74329 9.23094 0.738063 9.37669 0.772396 9.5156C0.806729 9.65451 0.87925 9.78103 0.981756 9.88087L6.06016 14.8305L4.86109 21.8209C4.83703 21.9618 4.85284 22.1066 4.90673 22.239C4.96061 22.3714 5.05043 22.4861 5.16604 22.5701C5.28165 22.6541 5.41845 22.7042 5.561 22.7146C5.70355 22.725 5.84617 22.6954 5.97276 22.629L12.2502 19.3277L18.5277 22.629C18.6543 22.6954 18.7969 22.725 18.9394 22.7146C19.082 22.7042 19.2188 22.6541 19.3344 22.5701C19.45 22.4861 19.5398 22.3714 19.5937 22.239C19.6476 22.1066 19.6634 21.9618 19.6394 21.8209L18.4403 14.8289L23.5187 9.88087C23.6212 9.78103 23.6937 9.65451 23.728 9.5156C23.7624 9.37669 23.7572 9.23094 23.713 9.09485C23.6688 8.95876 23.5874 8.83775 23.478 8.74551C23.3686 8.65328 23.2356 8.5935 23.094 8.57294L16.0759 7.55327L12.9372 1.19454Z"
					fill="#C8D2DB"
				/>
			</g>
			<g clipPath="url(#clip1_519_1517)">
				<path
					d="M11.846 0.883524C11.9674 0.808215 12.1074 0.768311 12.2502 0.768311V19.3277L5.97276 22.629C5.84617 22.6954 5.70355 22.725 5.561 22.7146C5.41845 22.7042 5.28165 22.6541 5.16604 22.5701C5.05043 22.4861 4.96061 22.3714 4.90673 22.239C4.85284 22.1066 4.83703 21.9618 4.86109 21.8209L6.06016 14.8305L0.981756 9.88087C0.87925 9.78103 0.806729 9.65451 0.772396 9.5156C0.738063 9.37669 0.74329 9.23094 0.787484 9.09485C0.831678 8.95876 0.913076 8.83775 1.02247 8.74551C1.13186 8.65328 1.26489 8.5935 1.40649 8.57294L8.42456 7.55327L11.5633 1.19454C11.6267 1.06655 11.7246 0.958833 11.846 0.883524Z"
					fill="#FFA310"
				/>
			</g>
			<defs>
				<clipPath id="clip0_519_1517">
					<rect
						width="23"
						height="23"
						fill="white"
						transform="translate(0.75)"
					/>
				</clipPath>
				<clipPath id="clip1_519_1517">
					<rect
						width="23"
						height="23"
						fill="white"
						transform="translate(0.75)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
